/*
 * TPL Collection Map
 * Desktop: pin click → fly-out card.
 * Mobile: persistent bottom sheet — pin ↔ row sync, sheet toggle, scroll-into-view.
 */
(function () {
  var mapEl = document.querySelector('[data-tpl-map]');
  if (!mapEl) return;

  var dataScript = mapEl.querySelector('[data-map-pins]');
  if (!dataScript) return;

  var pinsData;
  try {
    pinsData = JSON.parse(dataScript.textContent || '[]');
  } catch (e) {
    return;
  }
  if (!Array.isArray(pinsData) || pinsData.length === 0) return;

  var canvas = mapEl.querySelector('[data-map-canvas]');
  var pins = mapEl.querySelectorAll('[data-pin-id]');
  var card = mapEl.querySelector('[data-pin-card]');
  var sheet = mapEl.querySelector('[data-pin-sheet]');
  var sheetToggle = mapEl.querySelector('[data-sheet-toggle]');
  var sheetList = mapEl.querySelector('[data-sheet-list]');
  var sheetRows = mapEl.querySelectorAll('[data-sheet-row]');

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function escapeHTML(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------
     DESKTOP CARD (fly-out on pin click) — unchanged behavior.
     ------------------------------------------------------------ */
  function renderCardHTML(p) {
    var whereParts = [];
    if (p.location_name) whereParts.push(escapeHTML(p.location_name));
    if (p.gps_label) whereParts.push(escapeHTML(p.gps_label));
    var whereHTML = whereParts.length ? '<div class="tpl-map__card-where">' + whereParts.join(' &middot; ') + '</div>' : '';
    var captionHTML = p.caption_line ? '<div class="tpl-map__card-caption">' + escapeHTML(p.caption_line) + '</div>' : '';
    var metaHTML = (p.edition_type === 'Limited Edition')
      ? '<div class="tpl-map__card-meta">Limited Edition</div>'
      : '';

    return (
      '<a class="tpl-map__card-inner" href="' + escapeHTML(p.url) + '">' +
        '<img class="tpl-map__card-thumb" src="' + escapeHTML(p.thumb) + '" alt="' + escapeHTML(p.title) + '" loading="lazy" width="168" height="208">' +
        '<div>' +
          metaHTML +
          '<div class="tpl-map__card-title">' + escapeHTML(p.title) + '</div>' +
          whereHTML +
          captionHTML +
          '<div class="tpl-map__card-cta">View &rarr;</div>' +
        '</div>' +
      '</a>'
    );
  }

  function positionCard(pinEl) {
    var pinRect = pinEl.getBoundingClientRect();
    var canvasRect = canvas.getBoundingClientRect();
    var leftPct = ((pinRect.left + pinRect.width / 2) - canvasRect.left) / canvasRect.width * 100;
    var topPct = ((pinRect.top + pinRect.height / 2) - canvasRect.top) / canvasRect.height * 100;
    var flipX = leftPct > 62;
    var flipY = topPct > 65;
    card.style.left = (flipX ? leftPct - 2 : leftPct + 3) + '%';
    card.style.top = (flipY ? topPct - 2 : topPct + 3) + '%';
    card.style.transform = 'translate(' + (flipX ? '-100%' : '0') + ', ' + (flipY ? '-100%' : '0') + ')';
  }

  function showDesktopCard(pinEl, data) {
    if (!card) return;
    card.innerHTML = renderCardHTML(data);
    positionCard(pinEl);
    card.hidden = false;
  }

  function hideDesktopCard() {
    if (card) card.hidden = true;
  }

  /* ------------------------------------------------------------
     MOBILE SHEET — persistent peek/expanded states + row sync.
     ------------------------------------------------------------ */
  function setSheetExpanded(expanded) {
    if (!sheet) return;
    if (expanded) {
      sheet.classList.add('is-expanded');
      if (sheetToggle) sheetToggle.setAttribute('aria-expanded', 'true');
    } else {
      sheet.classList.remove('is-expanded');
      if (sheetToggle) sheetToggle.setAttribute('aria-expanded', 'false');
    }
  }

  function findRowById(id) {
    for (var i = 0; i < sheetRows.length; i++) {
      if (sheetRows[i].getAttribute('data-sheet-row') === id) return sheetRows[i];
    }
    return null;
  }

  function clearActiveAll() {
    for (var i = 0; i < pins.length; i++) pins[i].classList.remove('is-active');
    for (var j = 0; j < sheetRows.length; j++) sheetRows[j].classList.remove('is-active');
  }

  function activatePin(id, opts) {
    opts = opts || {};
    var pinEl = null;
    for (var i = 0; i < pins.length; i++) {
      if (pins[i].getAttribute('data-pin-id') === id) { pinEl = pins[i]; break; }
    }
    if (!pinEl) return;

    var data = null;
    for (var k = 0; k < pinsData.length; k++) {
      if (pinsData[k].id === id) { data = pinsData[k]; break; }
    }
    if (!data) return;

    clearActiveAll();
    pinEl.classList.add('is-active');

    if (isMobile()) {
      // Mobile flow: highlight row inline (caption + "Tap again to view" CTA appear
      // inside the row via CSS). Sheet stays at peek so the map remains visible.
      // User can drag the handle to expand the list if they want all 9 at once.
      var row = findRowById(id);
      if (row) {
        row.classList.add('is-active');
        // Scroll inside the sheet's list so the activated row is at the top of
        // the visible area — its expanded caption + CTA fit within peek state.
        if (sheetList) {
          var rowTop = row.offsetTop - sheetList.offsetTop;
          sheetList.scrollTo({ top: Math.max(0, rowTop - 8), behavior: 'smooth' });
        }
      }
      hideDesktopCard();
    } else {
      // Desktop card flow
      showDesktopCard(pinEl, data);
    }
  }

  function closeAll() {
    clearActiveAll();
    hideDesktopCard();
  }

  /* ------------------------------------------------------------
     EVENT WIRING
     ------------------------------------------------------------ */

  // Pins
  for (var i = 0; i < pins.length; i++) {
    (function (pin) {
      pin.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        activatePin(pin.getAttribute('data-pin-id'));
      });
    })(pins[i]);
  }

  // Sheet rows — tap highlights pin + visually selects row, but follows the link on second tap (or just lets the link work?)
  // UX choice: first tap = highlight pin + row, do NOT navigate. Second tap on same active row = navigate.
  // This gives users a chance to "preview" the location before committing.
  for (var r = 0; r < sheetRows.length; r++) {
    (function (row) {
      row.addEventListener('click', function (e) {
        var id = row.getAttribute('data-sheet-row');
        if (row.classList.contains('is-active')) {
          // Second tap on already-active row → let the link navigate
          return;
        }
        e.preventDefault();
        activatePin(id, { expand: true });
      });
    })(sheetRows[r]);
  }

  // Sheet toggle (drag handle)
  if (sheetToggle) {
    sheetToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      setSheetExpanded(!sheet.classList.contains('is-expanded'));
    });
  }

  // Outside click closes desktop card, collapses mobile sheet
  document.addEventListener('click', function (e) {
    if (mapEl.contains(e.target)) return;
    if (isMobile()) {
      setSheetExpanded(false);
      clearActiveAll();
    } else {
      closeAll();
    }
  });

  // Escape closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      if (isMobile()) {
        setSheetExpanded(false);
        clearActiveAll();
      } else {
        closeAll();
      }
    }
  });

  // Resize: clear any active state to avoid broken between-breakpoint UI
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      clearActiveAll();
      hideDesktopCard();
      setSheetExpanded(false);
    }, 200);
  });
})();
